import React, { useState, useEffect, useContext, useRef } from "react";
import { Container, Spinner } from "react-bootstrap";
import ResponsiveTable from "../Grid/ResponsiveTable";
import viewIcon from "../../assets/icons/view.svg";
import Alert from "../common/Alert";
import constants from "../../utils/dynamicformconstants";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from "../../assets/loader.gif";
import {
  getFormFields,
  getResponsiveTableData,
  deleteData,
} from "../../services/dynamic-service";
import { AuthContext } from "../../contexts/AuthContext";
import AddEnquiryMaster from "../Masters/EnquiryMaster/AddEnquiryMaster";
import DiscountAdd from "../Masters/EnquiryMaster/DiscountAdd";
import AddTimelineMaster from "../Masters/EnquiryMaster/AddTimelineMaster";
import AddOrderBooking from "../Orderbooking/AddOrderBooking";

const DynamicSearchForm = (props) => {
  console.log("props in dynamic search", props);
  const context = useContext(AuthContext);
  const companyCode = context.company_code;
  const companyCodeParam = ["lookupcode", "year", "user"];
  const [action, setAction] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [rowData, setRowData] = useState({});
  const [reload, setReload] = useState(false);
  const [data, setData] = useState([]);
  const [roleData, setRoleData] = useState([]);
  const [errorMessage, setErrorMessage] = useState();
  const [formFields, setFormFields] = useState();
  const [isDataReceived, setDataReceived] = useState(false);
  const [headers, setHeaders] = useState();
  const [showEditIcon, setShowEditIcon] = useState(false);
  const [enquiryData, setEnquiryData] = useState(null);
  const location = useLocation();

  const title = props.title;
  console.log("title", title);
  const handleAdd = () => {
    setAction("Add");
    setShowForm(true);
    title === "Company"
      ? setRowData({ enable: "Active" })
      : setRowData({ company_code: companyCode, enable: "Active" });
  };

  const loadform = async (showform = false) => {

    let apiparam = companyCodeParam.indexOf(props.apimethod) === -1 ? "" : companyCode;
    try {
      // const data = await getResponsiveTableData(props.apimethod, apiparam);
      // Promise.all([data])
      //   .then((responses) => {
      //     console.log("DynamicSearchForm responses : ", responses[0].searchdata);
      //     if (responses[0].searchdata) {
      //       console.log("responses[0].headers : ", responses);
      //       setHeaders(responses[0].headers);
      //       setData(responses[0].searchdata.data);
      //     } else {
      //       setHeaders([]);
      //       setData([]);
      //       Alert("error", "Sharepoint service is not available. please contact system admin")
      //     }
      //     setDataReceived(true);
      //     setLoading(false);
      //     setShowForm(showform);
      //   })
      //   .catch((error) => {
      //     setLoading(false);
      //     Alert("error", "Error in processing " + props.title + ". please try again");

      //     console.log("error in dynamic form", error);
      //     Alert("error", error);
      //   });


      const data = await getResponsiveTableData(props.apimethod, apiparam);
      if (data.searchdata) {
        setHeaders(data.headers);
        setData(data.searchdata.data);
      } else {
        setHeaders([]);
        setData([]);
        Alert("error", "Sharepoint service is not available. please contact system admin");
      }
      setDataReceived(true);
      // Only set showForm if explicitly requested, not during regular data refresh
      if (showform === true) {
        setShowForm(true);
      }
      setLoading(false);
    }
    catch (exception) {
      Alert("error", "Error in processing " + props.title + ". please try again");
      console.log("exception", exception)
    }
  }



  useEffect(() => {
    if (props.page === "AddOrderBooking" && location.state?.openAdd) {
      setAction("Add");
      setEnquiryData(location.state.enquiryData || null);
      setRowData(location.state.orderBookingFormData || {});
      setShowForm(true);
      setLoading(false);
      setDataReceived(true);
      // Clear the state so it doesn't re-trigger on re-renders
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const prevShowFormRef = useRef(false);
  useEffect(() => {
    const wasOpen = prevShowFormRef.current;
    prevShowFormRef.current = showForm;
    // When AddOrderBooking form is open, skip API call
    if (props.page === "AddOrderBooking" && showForm) return;
    // When AddOrderBooking form just opened (false→true), skip — already guarded above
    // When on initial mount and form is not open, OR when form closes (true→false), load data
    if (props.page === "AddOrderBooking" && !showForm && !wasOpen && isDataReceived) return;
    const fetchData = async () => {
      setLoading(true);
      await loadform(false);
    };
    fetchData();
  }, [reload, props.apimethod, showForm]);

  function setStatus(item) {
    let result = getResponsiveTableData(item);
    result
      .then((resp) => {
        Alert("success", "Status Updated Successfully");
        getResponsiveTableData();
      })
      .catch((error) => {
        Alert("error", error);
      });
  }


  let icons = [{ src: viewIcon, click: edit, name: "View" }];


  function edit(item) {
    console.log(" item ", item);
    setAction("View");
    setRowData(item);
    setShowForm(true);
    setShowEditIcon(false);
  }

  async function edit1(item) {
    setLoading(true);
    setAction("Edit");
    setReload(!reload);
    setRowData(item);
    setShowForm(true);
    setLoading(false);

    console.log("dataentry use effect edit 1: ", formFields);



  }
  function delet(item) {
    const MySwal = withReactContent(Swal);
    let title = "Delete " + props.title;
    let confirmationMessage =
      "Are you sure, you want to Delete this " + props.title + "?";
    MySwal.fire({
      title: title,
      html: confirmationMessage,
      ...constants.CONFIRMATION_BOX_CONFIG,
    }).then(async (selection) => {
      if (selection.isConfirmed) {
        setLoading(true);
        let result;
        result = deleteData(props.apimethod, item);
        result
          .then((resp) => {
            Alert("success", resp.Message);
            loadform();
          })
          .catch((err) => {
            setErrorMessage(err);
          });
        setLoading(false);
      }
    });
  }

  return (
    <>
      {loading && (
        <div className="loader-box">
          {" "}
          <img src={Loader} alt="Loading" className="newloader"></img>{" "}
        </div>
      )}


      {showForm && props.page === "AddEnquiryMaster" && (
        <AddEnquiryMaster
          show={showForm}
          action={action}
          rowdata={rowData}
          setReload={() => setReload(!reload)}
          onHide={() => setShowForm(false)}
        />
      )}

      {showForm && props.page === "AddTimelineMaster" && (
        <AddTimelineMaster
          rowdata={rowData}
          show={showForm}
          action={action}
          setReload={() => setReload(!reload)}
          onHide={() => setShowForm(false)}
        />
      )}
      {showForm && props.page === "AddOrderBooking" && (
        <AddOrderBooking
          rowdata={rowData}
          show={showForm}
          action={action}
          enquiryData={enquiryData}
          setReload={() => setReload(!reload)}
          onHide={() => { setShowForm(false); setEnquiryData(null); }}
        />
      )}
      {showForm && props.page === "DiscountAdd" && (
        <DiscountAdd
          show={showForm}
          action={action}
          rowdata={rowData}
          setReload={() => setReload(!reload)}
          onHide={() => setShowForm(false)}
        />
      )}


      {/* <CustomBreadcrumb parentMenu={"Master"} menu={props.title}>
        {" "}
      </CustomBreadcrumb> */}
      {!(showForm && props.page === "AddOrderBooking") && (
        <Container bsPrefix="main-body">
          {/* <div className="page-title">{props.title}</div>
          <div className="page-sub-title">
            Add or Edit {props.title.replace("Maintain", "")}
          </div> */}
          {isDataReceived && (
            <ResponsiveTable
              key={props.apimethod}
              headers={headers}
              data={data}
              icons={icons}
              dataType={props.title}
              button={props.title.replace("Maintain", "")}
              handleAdd={handleAdd}
              sessionName={props.title}
              DisplayExcelDownload={true}
              showEditIcon={showEditIcon}
              setShowEditIcon={setShowEditIcon}
              loadform={() => loadform(false)}
            //  reload={reload}

            ></ResponsiveTable>
          )}
        </Container>
      )}
    </>
  );

};
export default DynamicSearchForm;
